// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"1b74f688","252":"15e12955","350":"b8e82f3f","412":"5555f5d1","458":"eddc5373","622":"7efbde45","749":"19fcb76a","782":"590a721b","848":"407d969b","852":"eb80a2ec","975":"0a7bb35b"}[chunkId] + ".chunk.js";
};